/**
 * This is mostly empty because we don't know what specific features HelpDesk will
 * need over Inbox
 *
 * We'll flesh this out once we start building out the Help Desk specific customizations
 */

export let LatestMessageAccess;
(function (LatestMessageAccess) {
  LatestMessageAccess["ACCESS"] = "ACCESS";
  LatestMessageAccess["NO_ACCESS"] = "NO_ACCESS";
})(LatestMessageAccess || (LatestMessageAccess = {}));